import { useMemo } from "react"
import { useQuery } from "urql"

import "../graphql/queries"

import { GetTransferProductInventoryListDocument, type InventoryByProductItem } from "@/graphql/codegen/graphql"

interface UseGetTransferProductInventoryParams {
  productId: number
  warehouseAreaId: string
}

interface UseGetTransferProductInventoryReturn {
  inventory: InventoryByProductItem | undefined
  isFetching: boolean
}

export const useGetTransferProductInventory = ({
  productId,
  warehouseAreaId,
}: UseGetTransferProductInventoryParams): UseGetTransferProductInventoryReturn => {
  const [{ data, fetching }] = useQuery({
    query: GetTransferProductInventoryListDocument,
    variables: { input: { filter: { productId, warehouseIds: [warehouseAreaId] }, limit: 1 } },
    requestPolicy: "cache-and-network",
  })

  const output = data?.inventory.listByProduct

  const inventory = useMemo(
    () =>
      output?.__typename === "InventoryByProductListSuccess"
        ? (output.items[0] as InventoryByProductItem | undefined)
        : undefined,
    [output]
  )

  return { inventory, isFetching: fetching }
}
